module.exports = __webpack_public_path__ + "assets/7b922e935b5ad8060bd38e9122ebc9c1.woff";


/*****************
 ** WEBPACK FOOTER
 ** ./~/@ergeon/erg-theme/app/fonts/Gotham-BoldItalic.woff
 ** module id = 1733
 ** module chunks = 1
 **/